import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const BispecificsCartTreatmentCohortService = {
  GetBispecificCartTreatmentCohortData,
  SaveBispecificCartTreatmentCohortData,
  GetBispecificInitiationData,
  SaveBispecificInitiationData,
};

function GetBispecificCartTreatmentCohortData(patientId) {
  return WebServiceWrapper.Get(
    `/bispecificsCartTreatmentCohort/GetBispecificCartTreatmentCohortData?patientId=${patientId}&isAdmin=${IsAdmin()}`
  );
}

function SaveBispecificCartTreatmentCohortData(payload) {
  return WebServiceWrapper.Post(
    "/bispecificsCartTreatmentCohort/SaveBispecificCartTreatmentCohortData",
    payload
  );
}

function GetBispecificInitiationData(patientId) {
  return WebServiceWrapper.Get(
    `/bispecificsCartTreatmentCohort/GetBispecificInitiationData?patientId=${patientId}&isAdmin=${IsAdmin()}`
  );
}

function SaveBispecificInitiationData(payload) {
  return WebServiceWrapper.Post(
    "/bispecificsCartTreatmentCohort/SaveBispecificInitiationData",
    payload
  );
}
